import {
  EmptyStateError,
  EmptyStateLoading,
  lazyLoad,
} from 'src/core/common/components/LazyLoad';

export const SpendLimitsPageLazy = lazyLoad({
  loader: async () => ({
    /* eslint-disable unicorn/no-await-expression-member */
    default: (
      await import(/* webpackChunkName: "SpendLimits" */ './SpendLimitsPage')
    ).SpendLimitsPage,
    /* eslint-enable */
  }),
  loading: <EmptyStateLoading />,
  fallback: (props) => <EmptyStateError {...props} />,
});
